import React from "react";
import {FormProvider, useForm} from "react-hook-form";

import {BudgetFieldMonthlyDefault, BudgetFieldTotalDefault} from "../../../real_estate/constants/budget_fields_defaults";
import {PreferencesAction} from "../../analytics/events";
import {additionalAreasCheckboxes, floorsCheckboxes, kitchenCheckboxes, wordDirectionCheckboxes} from "../../constants/configurator_checkboxes_lists";
import {SearchFormValuesType} from "../../views/PropertyConfigurator";
import {AreaFilter} from "../AreaFilter";
import {BudgetFilter} from "./BudgetFilter";
import {ConfiguratorCheckboxes} from "./ConfiguratorCheckboxes";
import {ConstructionEndDateFilter} from "./ConstructionEndDateFilter";
import {RoomFilter} from "./RoomFilter";

interface IProps {
    values: SearchFormValuesType;
    onChange: (value: Partial<SearchFormValuesType>) => void;
}

export enum BudgetFieldsNames {
    RADIO = "filterBudget",
    TOTAL = "budgetTotal",
    CREDIT = "budgetCredit"
}

export const FiltersForm = ({...filterProps}: IProps) => {
    const formMethods = useForm({
        defaultValues: {
            [BudgetFieldsNames.TOTAL]: filterProps.values.price.upper || BudgetFieldTotalDefault,
            [BudgetFieldsNames.CREDIT]: filterProps.values.instalment || BudgetFieldMonthlyDefault,
            [BudgetFieldsNames.RADIO]: filterProps.values.instalment > 0 ? "monthly" : "total"
        }
    });

    return (
        <>
            <FormProvider {...formMethods}>
                <BudgetFilter {...filterProps} />
            </FormProvider>

            <ConstructionEndDateFilter {...filterProps} />

            <RoomFilter {...filterProps} singleChoice />

            <AreaFilter {...filterProps} />

            <ConfiguratorCheckboxes
                checkboxList={additionalAreasCheckboxes(true)}
                header="Powierzchnie dodatkowe"
                gtmAction={PreferencesAction.ADDITIONAL_SPACES}
                isOnSidebar
                segmentWrapperClassName="checkboxesSegmentStyle"
            />

            <ConfiguratorCheckboxes
                checkboxList={kitchenCheckboxes(true)}
                header="Kuchnia"
                gtmAction={PreferencesAction.KITCHEN_TYPE}
                isOnSidebar
                segmentWrapperClassName="checkboxesSegmentStyle"
            />

            <ConfiguratorCheckboxes
                checkboxList={floorsCheckboxes(true)}
                header="Piętro"
                gtmAction={PreferencesAction.FLOOR}
                isOnSidebar
                segmentWrapperClassName="checkboxesSegmentStyle"
            />

            <ConfiguratorCheckboxes
                checkboxList={wordDirectionCheckboxes(true)}
                header="Strona świata"
                gtmAction={PreferencesAction.WORLD_DIRECTION}
                isOnSidebar
                segmentWrapperClassName="checkboxesSegmentStyle"
            />
        </>
    );
};
import React from "react";
import {FormProvider, useForm} from "react-hook-form";

import {BudgetFieldMonthlyDefault, BudgetFieldTotalDefault} from "../../../real_estate/constants/budget_fields_defaults";
import {PreferencesAction} from "../../analytics/events";
import {additionalAreasCheckboxes, floorsCheckboxes, kitchenCheckboxes, wordDirectionCheckboxes} from "../../constants/configurator_checkboxes_lists";
import {SearchFormValuesType} from "../../views/PropertyConfigurator";
import {AreaFilter} from "../AreaFilter";
import {BudgetFilter} from "./BudgetFilter";
import {ConfiguratorCheckboxes} from "./ConfiguratorCheckboxes";
import {ConstructionEndDateFilter} from "./ConstructionEndDateFilter";
import {RoomFilter} from "./RoomFilter";

interface IProps {
    values: SearchFormValuesType;
    onChange: (value: Partial<SearchFormValuesType>) => void;
}

export enum BudgetFieldsNames {
    RADIO = "filterBudget",
    TOTAL = "budgetTotal",
    CREDIT = "budgetCredit"
}

export const FiltersForm = ({...filterProps}: IProps) => {
    const formMethods = useForm({
        defaultValues: {
            [BudgetFieldsNames.TOTAL]: filterProps.values.price.upper || BudgetFieldTotalDefault,
            [BudgetFieldsNames.CREDIT]: filterProps.values.instalment || BudgetFieldMonthlyDefault,
            [BudgetFieldsNames.RADIO]: filterProps.values.instalment > 0 ? "monthly" : "total"
        }
    });

    return (
        <>
            <FormProvider {...formMethods}>
                <BudgetFilter {...filterProps} />
            </FormProvider>

            <ConstructionEndDateFilter {...filterProps} />

            <RoomFilter {...filterProps} singleChoice />

            <AreaFilter {...filterProps} />

            <ConfiguratorCheckboxes
                checkboxList={additionalAreasCheckboxes(true)}
                header="Powierzchnie dodatkowe"
                gtmAction={PreferencesAction.ADDITIONAL_SPACES}
                isOnSidebar
                segmentWrapperClassName="checkboxesSegmentStyle"
            />

            <ConfiguratorCheckboxes
                checkboxList={kitchenCheckboxes(true)}
                header="Kuchnia"
                gtmAction={PreferencesAction.KITCHEN_TYPE}
                isOnSidebar
                segmentWrapperClassName="checkboxesSegmentStyle"
            />

            <ConfiguratorCheckboxes
                checkboxList={floorsCheckboxes(true)}
                header="Piętro"
                gtmAction={PreferencesAction.FLOOR}
                isOnSidebar
                segmentWrapperClassName="checkboxesSegmentStyle"
            />

            <ConfiguratorCheckboxes
                checkboxList={wordDirectionCheckboxes(true)}
                header="Strona świata"
                gtmAction={PreferencesAction.WORLD_DIRECTION}
                isOnSidebar
                segmentWrapperClassName="checkboxesSegmentStyle"
            />
        </>
    );
};
